import { useEffect, useState } from "react";
import req from "../../../../modules/Request";
import { useNotifyContext } from "../../../components/Notify";
import * as session from "../../../../modules/Stash/Stash";

const useInterventions = ({ show }) => {
  const [ interventions, setInterventions ] = useState(session.getStore("interventions") || []);
  const { notify } = useNotifyContext();

  useEffect(() => {
    const fetchInterventions = async () => {
      const res = await req("select-interventions");

      if (res.success) {
        const newDate = res.data.map(item => ({ ...item, value: item.id, label: item.description }));
        session.addStore("interventions", newDate);
        setInterventions(newDate);
      } else {
        notify("Error", "Please contact the administrator", 'error');
      }
    };

    if (show) fetchInterventions();
  }, [ show ]);

  return interventions;
};

export default useInterventions;